import React, { FC } from 'react'
import clsx from 'clsx'

import EmptyInbox from 'assets/images/empty_inbox.png'
import AssignmentDetails from 'container/AssignmentDetails/AssignmentDetails'

import styles from './_.module.css'
import { Helmet } from 'react-helmet'
import { StringParam, useQueryParam } from 'use-query-params'

interface SideAssignmentProps {
  assignmentDetails?: string
  hideSideLoad?: () => void
  refetch?: () => void
}

const SideModalDetails: FC<SideAssignmentProps> = ({
  assignmentDetails,
  hideSideLoad,
  refetch,
}) => {
  const [title] = useQueryParam('project_title', StringParam)

  if (assignmentDetails) {
    return (
      <div
        className={clsx(styles.sideExpandedWrap, styles.boxShadow)}
        id="side-details-expanded"
      >
        <Helmet>
          <title>{title ?? ''}</title>
        </Helmet>
        <AssignmentDetails
          keepSamePage={true}
          assignmentDetails={assignmentDetails}
          hideSideLoad={hideSideLoad}
          refetch={refetch}
        />
      </div>
    )
  } else {
    return (
      <div className={clsx(styles.sideExpandedEmpty, styles.boxShadow)}>
        <img src={EmptyInbox} width="414" height="302" alt="Empty inbox" />
      </div>
    )
  }
}

export default SideModalDetails
